// extracted by mini-css-extract-plugin
export default {"body":"style_body__NVNh1","cover":"style_cover__rU6to","lead":"style_lead__YgF-B","footer":"style_footer__3rhge","error":"style_error__Txt6h","btn":"style_btn__bYN1w"};